import LayOut from "./components/shared/LayOut";
import "../src/styles/customStyles.css";

export default function App() {
  return <LayOut />;
}
